import { theme } from '@by-miles/bymiles-styles'
import React from 'react'

import { StepBulletStyles } from './StepBulletStyles'

interface StepBulletProps {
  percentage: number
  bullet: number
  active: boolean
}

export const StepBullet = ({ percentage, bullet, active }: StepBulletProps) => {
  const radius = 15
  const strokeWidth = 3
  const circumference = 2 * Math.PI * radius
  const dashOffset = circumference - (percentage / 100) * circumference

  return (
    <StepBulletStyles>
      <svg width="35" height="35" viewBox="0 0 33 33">
        <circle
          cx="16.5"
          cy="16.5"
          r={radius}
          stroke={theme.tints.darkAubergine}
          strokeWidth={strokeWidth}
          fill="transparent"
        />
        <circle
          cx="16.5"
          cy="16.5"
          r={radius}
          stroke={theme.primaryColours.aubergine.main}
          strokeWidth={strokeWidth}
          fill="transparent"
          strokeDasharray={circumference}
          strokeDashoffset={dashOffset}
          strokeLinecap="round"
          transform="rotate(-90 16.5 16.5)"
          style={active ? { transition: 'stroke-dashoffset 0.8s ease-out' } : {}}
        />
        <text
          x="17"
          y="17"
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize="14"
          fontWeight={400}
          fontFamily="BM-Biotif"
        >
          {bullet}
        </text>
      </svg>
    </StepBulletStyles>
  )
}
